import styled from 'styled-components';
import { bgWhite, containerWidth } from '../../constants/theme';

export const HeaderFixed = styled.div`
  position: relative;
  width: 100%;
  position: fixed;
  background-color: ${bgWhite};
  top: 0;
  z-index: 99;
  width: ${containerWidth};
  }
`;
